import script from "./ProductAvailability.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductAvailability.vue?vue&type=script&setup=true&lang=js"

import "./ProductAvailability.vue?vue&type=style&index=0&id=7a45cc78&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/mayesh.com/httpdocs/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a45cc78"]])

export default __exports__